import { createFileRoute } from "@tanstack/react-router";

import { SessionsPage } from "../../../workspaces/worlds/pages/SessionsPage";

export const Route = createFileRoute("/_console/p/$org/$project/simulate/sessions")({
  component: SessionsPage,
});
